import config from '@/config/config'
import axios from 'axios'

export default {
    state: {
        currentUser: localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null,
        news: [],
        loginError: null,
        processing: false,
        countDown: 600
    },
    getters: {
        currentUser: state => state.currentUser,
        news: state => state.news,
        processing: state => state.processing,
        loginError: state => state.loginError,
        countDown: state => state.countDown
    },
    mutations: {
        setUser (state, payload) {
            state.currentUser = payload
            state.processing = false
            state.loginError = null
        },
        setNews (state, payload) {
            state.news = payload
        },
        setLogout (state) {
            state.currentUser = null
            state.processing = false
            state.loginError = null
        },
        setProcessing (state, payload) {
            state.processing = payload
            state.loginError = null
        },
        setError (state, payload) {
            state.loginError = payload
            state.currentUser = null
            state.processing = false
        },
        clearError (state) {
            state.loginError = null
        },
        setCountDown (state, payload) {
            state.countDown = payload
        },
        decCountDown (state) {
            state.countDown--
        }
    },
    actions: {
        login ({commit}, payload) {
            commit('clearError')
            commit('setProcessing', true)

            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl() + 'login', payload).then(response => {
                    localStorage.setItem('token', response.data.token)
                    localStorage.setItem('expires', response.data.expires)
                    localStorage.setItem('tempTermed', response.data.terms)
                    localStorage.setItem('user', JSON.stringify(response.data.user))
                    axios.defaults.headers.common['Authorization'] = 'bearer ' + response.data.token
                    commit('setUser', response.data.user)
                    commit('setNews', response.data.news)
                }, err => {
                    if (err.response) {
                        commit('setError', err.response.data)
                        localStorage.removeItem('token')
                        localStorage.removeItem('user')
                        localStorage.removeItem('expires')
                        reject(err.response.data)
                    } else {
                        commit('setError', {msg: 'The server did not respond.'})
                        reject(err)
                    }
                })
            })
        },
        logout ({commit}) {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('expires')
            commit('setLogout')
        },
        changePassword ({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl() + 'change-password', payload).then(response => {
                    resolve(response.data)
                }, err => {
                    reject(err)
                })
            })
        }
    }
}
